import { render, staticRenderFns } from "./PaymentsForm.vue?vue&type=template&id=f427e54e"
import script from "./PaymentsForm.vue?vue&type=script&lang=js"
export * from "./PaymentsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports